const TradingPhotoCardSkeleton = () => {
  return (
    <div className="flex flex-col gap-[12px]">
      {Array.from({ length: 3 }).map((_, index) => (
        <div
          key={index}
          className="w-full h-[144px] rounded-[16px] bg-gray-200 dark:bg-gray-700 animate-pulse"
        />
      ))}
    </div>
  );
};

export default TradingPhotoCardSkeleton;
